<template>
  <div>
    <!-- <img src="../assets/images/bg.png" alt="bg1" class="background-image1" /> -->
    <transition appear
                @before-enter="$animations.beforeEnterLogoArea"
                @enter="$animations.enterLogoArea"
    >
      <Logo></Logo>
    </transition>

<!--    <transition appear-->
<!--                @before-enter="$animations.beforeEnterAbove"-->
<!--                @enter="$animations.enterAbove"-->
<!--    >-->
<!--      <div class="columns is-centered mt-1">-->
<!--        <div class="column is-half ps-5" style="text-align: center;font-family: OpenSans-Bold ;">-->
<!--          <p-->
<!--              :class="`text-center mx-3 ${-->
<!--            $root.selectedLanguage === `ta`-->
<!--              ? `ta-line`-->
<!--              : $root.selectedLanguage === `si`-->
<!--              ? `si-line`-->
<!--              : `en-line`-->
<!--          }`"-->
<!--          >-->
<!--            {{ $root.selectedLanguageData.welcome }}-->
<!--          </p>-->
<!--          <p-->
<!--              :class="`${-->
<!--            $root.selectedLanguage === `ta`-->
<!--              ? `ta-sub-line`-->
<!--              : $root.selectedLanguage === `si`-->
<!--              ? `si-sub-line`-->
<!--              : `en-sub-line`-->
<!--          }`"-->
<!--          style="font-family: OpenSans-Medium ;"-->
<!--          >-->
<!--            {{ $root.selectedLanguageData.onlineaccountopeningapplication }}-->
<!--          </p>-->
<!--        </div>-->
<!--      </div>-->
<!--    </transition>-->

    <transition appear
                @before-enter="$animations.beforeEnterBelow"
                @enter="$animations.enterBelow"
    >
      <div class="opacity-select-card card" style="width: 80%; margin: 100px auto; bottom: 20%;">
        <header class="card-header">
          <p class="card-header-title is-centered is-size-4"  style="font-family: OpenSans-Bold ; color: white">
            {{ $root.selectedLanguageData.notice }}
          </p>
        </header>
        <div class="card-content">
          <ul class="example-ul mx-6 has-text-left">
            <li class="mb-1">
              {{ $root.selectedLanguageData.line_1 }}
            </li>
            <li class="mb-1">
              {{ $root.selectedLanguageData.line_2
              }}<span class="has-text-weight-bold">
              {{ $root.selectedLanguageData.line_2_highlight }}</span
            >
            </li>
            <!-- <li class="mb-3">
              {{ $root.selectedLanguageData.line_3 }}
            </li>
            <li class="mb-3">
              {{ $root.selectedLanguageData.line_4 }}
            </li>
            <li class="mb-3">
              {{ $root.selectedLanguageData.line_5 }}
            </li>
            <li class="mb-3">
              {{ $root.selectedLanguageData.line_6 }}
            </li>
            <li class="mb-3">
              {{ $root.selectedLanguageData.line_7 }}
            </li>
            <li class="mb-1">
              {{ $root.selectedLanguageData.line_8 }}
            </li> -->



            <li class="mb-2 has-text-weight-bold has-text-left specific">
              {{ $root.selectedLanguageData.notice_content_1 }}
            </li>
          </ul>
        </div>
        <div class="is-flex is-justify-content-flex-end pb-4">
          <b-button class="reject-button" @click="rejectRouteNavigator()">
            <!-- rounded propertiey has removed -->
            {{ $root.selectedLanguageData.reject }}
          </b-button>
          <b-button
              class="is-primary mr-4 agree-button"
              @click="$router.push('account-info')"
              :loading="continueButtonIsLoading"
             
          >
            {{ $root.selectedLanguageData.agree }}
          </b-button>
        </div>
      </div>
    </transition>


    <GetHelp v-if="false"></GetHelp>
  </div>
</template>
<script>
import GetHelp from "./GetHelp.vue";
import Logo from "./NsbKycLogo.vue";
import {getBranchesList, getOtherBankList, getCountyCodeList} from "@/util/util"
export default {
  components: {
    GetHelp,
    Logo,
  },
  data() {
    return {
        continueButtonIsLoading: false,
        getBranchesList : getBranchesList,
        getOtherBankList : getOtherBankList,
        getCountyCodeList : getCountyCodeList
    };
  },
  methods: {

      // getColorCodeData () {
      //   let kyc_token = this.$root.formData.kyc_token
      //   this.continueButtonIsLoading = true;
      //     this.$http
      //         .post(this.$baseURL + "/kycForm/getColorCode", {},{
      //           headers:{'X-token':kyc_token}
      //         })
      //         .then((response) => {
      //             console.log(response);
      //
      //             // enable continue button after the response
      //             this.continueButtonIsLoading = false;
      //
      //             if (response.data.success) {
      //                 this.$root.formData.color_code1 = response.data.data.color_code1;
      //                 this.$root.formData.color_code2 = response.data.data.color_code2;
      //                 this.$root.formData.color_code3 = response.data.data.color_code3;
      //                 this.$root.formData.color_code4 = response.data.data.color_code4;
      //                 this.$root.formData.color_code5 = response.data.data.color_code5;
      //                 this.$root.formData.color_code6 = response.data.data.color_code6;
      //                 this.$root.formData.color_code7 = response.data.data.color_code7;
      //                 this.$root.formData.color_code8 = response.data.data.color_code8;
      //                 this.$root.formData.color_code9 = response.data.data.color_code9;
      //                 this.$root.formData.color_code10 = response.data.data.color_code10;
      //                 this.$root.formData.color_code11 = response.data.data.color_code11;
      //                 this.$root.formData.color_code12 = response.data.data.color_code12;
      //                 this.$root.formData.color_code13 = response.data.data.color_code13;
      //                 this.$root.formData.color_code14 = response.data.data.color_code14;
      //                 this.$root.formData.color_code15 = response.data.data.color_code15;
      //                 this.$root.formData.color_code16 = response.data.data.color_code16;
      //
      //                 this.$router.push('account-info')
      //             }
      //             else {
      //                 this.$buefy.toast.open({
      //                     message: "Failed to get customer auth tokens",
      //                     type: "is-danger",
      //                 });
      //             }
      //         }).catch((response) => {
      //             this.$buefy.toast.open({
      //                 message: response.message,
      //                 type: "is-danger",
      //             });
      //     });
      // }
    // getBranchesList(){
    //   try{
    //     let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
    //     this.$http
    //         .post(this.$baseURL + "/kycForm/getBranches", {},{
    //           headers:{'X-token':kyc_token}
    //         })
    //         .then((response) => {
    //           //console.log(response.data.data.branches);
    //           this.$root.dataLists.branchListArray = response.data.data.branches;
    //         })
    //   }catch(err){
    //     console.log(err)
    //   }
    // },

    //   getOtherBankList(){
    //   try{
    //     let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
    //     this.$http
    //         .post(this.$baseURL + "/kycForm/getOtherBankBranchesList", {},{
    //           headers:{'X-token':kyc_token}
    //           })
    //         .then((response) => {
    //           console.log("Other Bank List ", response.data);
    //           this.$root.dataLists.otherBankAndBranchList = Object.values(response.data.banksWithBranches);
    //           // console.log("this.$root.formData.otherBankAndBranchList", this.$root.formData.otherBankAndBranchList);
              
    //         })
    //   }catch(err){
    //     console.log(err)
    //   }
    // },

   



    rejectRouteNavigator(){
      this.$router.push('/');
      window.location.reload();

    },

    // getCountyCodeList(){
    //   try{
    //     let kyc_token = this.$root.formData.kyc_token +'.'+ this.$root.formData.color_code4 +'.'+ this.$root.formData.color_code12;
    //     this.$http
    //         .post(this.$baseURL + "/getAllCountries", {},{
    //           headers:{'X-token':kyc_token}
    //         })
    //         .then((response) => {
    //           //console.log(response.data.countries);

    //           this.$root.dataLists.countryCodeListArray = response.data.data.countries;
    //           this.$root.dataLists.countryCodeListArray.forEach(country =>{
    //             this.$root.dataLists.countryCodeNumbersListArray.push(country.phone)
    //           })

    //           //console.log("new array")
    //           //console.log(this.$root.formData.countryCodeNumbersListArray)

    //         })

    //   }catch(err){
    //     console.log(err)
    //   }
    // },

    

  },
  created() {
    this.getBranchesList();
    this.getOtherBankList();
   
  },
  mounted() {
    this.getCountyCodeList()
  }
};
</script>
<style lang="scss" scoped>
// .example-ul {
//   list-style: disc;
// }
ul li::before {
  content: "\2022";
  color: #009ec2;
  font-weight: bold;
  display: inline-block;
  width: 1em;
  margin-left: -1em;
}
.specific {
  margin-left: -20px;
  line-height: 1.5rem;
}
</style>
